<template>
  <div class="container py-4">
    <div class="container px-md-5">
      <apnic-search></apnic-search>
      <apnic-spinner>
        <apnic-result v-if="$store.getters['searchStore/dataIsReady']"></apnic-result>
        <apnic-search-error v-if="$store.getters['searchStore/error']" :searchType="searchType"></apnic-search-error>
      </apnic-spinner>
    </div>
  </div>
</template>

<script>
import Search from "../components/Search";
import SearchResult from "../components/SearchResult";
import SearchError from "../components/SearchError";
import SearchSpinner from "../components/SearchSpinner";
export default {
	data() {
		return {
			searchType: null
		};
	},
	components: {
		apnicSearch: Search,
		apnicSearchError: SearchError,
		apnicResult: SearchResult,
		apnicSpinner: SearchSpinner
	},
	watch: {
		$route(route) {
			this.checkRoute(route);
		}
	},
	created() {
		this.$store.dispatch("searchStore/clearSearchResult");
		this.checkRoute(this.$route);
	},
	methods: {
		checkRoute(route) {
			this.searchType = null;
			if (route.name === "home") {
				this.$store.dispatch("searchStore/clearSearchResult");
				return;
			}

			const nameList = ["autnum", "ip", "entity"];
			// check /autnum, /ip and /entity
			for (let i in nameList) {
				if (nameList[i] === route.name) {
					this.$router.push("/");
					return;
				}
			}
			// define search type
			for (let i in nameList) {
				if (route.name.indexOf(nameList[i]) !== -1) {
					this.searchType = nameList[i];
					break;
				}
			}
			const { bits, address } = route.params;
			this.$store.dispatch("searchStore/search", {
				type: this.searchType,
				address,
				bits
			});
		}
	}
};
</script>

<style scoped>
</style>
